import React from 'react';

import { PRO_IMAGE_URLS } from './constants';

const ProSection = () => (
  <section className="relative -mx-16 bg-[linear-gradient(to_bottom,#f0ece5_60%,#c5a26d_100%)] px-16 py-64 sm:-mx-28 sm:px-28 sm:py-112">
    <div className="mx-auto flex max-w-[1174px] flex-col gap-64 md:flex-row md:items-center">
      {/* Left: text block */}
      <div className="flex flex-col gap-16 md:max-w-[500px] md:shrink-0">
        <h2 className="m-0 font-suisse-works text-headline-sm text-black sm:text-headline-lg md:text-headline-xl">
          The Information <span className="text-pro-gold">Pro</span>
        </h2>
        <p className="m-0 border-t-2 border-solid border-grayscale-beige font-suisse-neue text-body-lg text-black">
          With The Information Pro, unlock our full suite of proprietary data tools alongside our
          exclusive reporting. Access AI-powered Deep Research, over 60 org charts, 12 specialized
          databases, and more—providing unparalleled and deep insight into the companies and people
          shaping tech and AI.
        </p>
      </div>

      <div className="flex flex-col items-center gap-32 sm:gap-56 md:flex-1">
        {PRO_IMAGE_URLS.map((imageUrl) => (
          <img
            key={imageUrl}
            className="block h-auto w-full object-cover odd:max-w-[478px]"
            src={imageUrl}
            role="presentation"
            loading="lazy"
          />
        ))}
      </div>
    </div>
  </section>
);

export default ProSection;
